module.exports = __webpack_public_path__ + "static/media/screenshot(29).1064957f.jpg";